module.exports = __webpack_public_path__ + "img/404_v2.546ddb38.png";